export default "__VITE_ASSET__DLNJAuzJ__"